import Dialog from "@rio-cloud/rio-uikit/Dialog";
import TripCardAddFile from "src/components/TripCardAdd/TripCardAddFile";
import TripCardAdd from "../../TripCardAdd";

interface Props {
  open: boolean;
  onClose: () => void;
  onClickSelectRoute: () => void;
  handleSelectFileModel: (json?: any[]) => void;
  handleSelectNewRoute: () => void;
}

const AddTrip = ({ open, onClose, onClickSelectRoute, handleSelectFileModel, handleSelectNewRoute }: Props) => {
  return (
    <Dialog
      show={open}
      title={"Agendar viagem"}
      onClose={onClose}
      body={
        <div className="display-flex flex-row gap-24 justify-content-center">
          <TripCardAdd
            icon="rioglyph rioglyph-route-option"
            text="Agendar viagem usando uma rota salva"
            textBtnNext="Continuar"
            onNext={onClickSelectRoute}
          />
          <TripCardAdd
            icon="rioglyph rioglyph-plus-light"
            text="Agendar viagem criando uma rota"
            textBtnNext="Continuar"
            onNext={handleSelectNewRoute}
          />
          <TripCardAddFile
            icon="rioglyph rioglyph-to-top "
            text="Agendar viagem criando a partir de um modelo"
            text2="Clique aqui ou arraste o modelo preenchido"
            textBtnDownload="Baixar modelo"
            onDownload={() => alert('Baixar modelo')}
            textBtnNext="Continuar"
            onNext={handleSelectFileModel}
          /> 
        </div>
      }
      className="exampleDialog"
      showCloseButton
      bsSize="lg"
    />
  );
};

export default AddTrip;
